// Counts down to the visitor's local midnight ("Get 2 free bottles until midnight").
if (!customElements.get('pga-countdown')) {
  class PgaCountdown extends HTMLElement {
    connectedCallback() {
      this.units = {
        h: this.querySelector('[data-unit="h"]'),
        m: this.querySelector('[data-unit="m"]'),
        s: this.querySelector('[data-unit="s"]'),
      };
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    tick() {
      const now = new Date();
      const midnight = new Date(now);
      midnight.setHours(24, 0, 0, 0);
      const left = Math.max(0, Math.floor((midnight - now) / 1000));
      const pad = (value) => String(value).padStart(2, '0');

      if (this.units.h) this.units.h.textContent = pad(Math.floor(left / 3600));
      if (this.units.m) this.units.m.textContent = pad(Math.floor((left % 3600) / 60));
      if (this.units.s) this.units.s.textContent = pad(left % 60);
    }
  }

  customElements.define('pga-countdown', PgaCountdown);
}
